<template>
  <!-- Mobile floating toggle (visível quando o drawer está fechado em mobile) -->
  <button
    v-if="isMobile && !mobileOpen"
    class="sb-mobile-toggle"
    @click="mobileOpen = true"
    aria-label="Abrir menu"
    title="Abrir menu"
  >
    <i class="fas fa-bars"></i>
  </button>

  <!-- Backdrop para o drawer mobile -->
  <transition name="sb-fade">
    <div
      v-if="isMobile && mobileOpen"
      class="sb-backdrop"
      @click="mobileOpen = false"
    ></div>
  </transition>

  <aside
    v-bind="$attrs"
    class="glass-sidebar"
    :class="{
      'is-collapsed': !isMobile && desktopCollapsed,
      'is-mobile-closed': isMobile && !mobileOpen,
      'is-mobile-open': isMobile && mobileOpen,
    }"
  >
    <!-- Top section -->
    <div class="sb-top">
      <div class="sb-brand">
        <button
          class="sb-collapse-btn"
          @click="toggleSidebar"
          :title="collapseTitle"
          aria-label="Alternar menu"
        >
          <i :class="['fas', collapseIcon]"></i>
        </button>
        <!-- <button
          class="sb-theme-btn"
          @click="toggleTheme"
          :title="theme === 'light' ? 'Modo escuro' : 'Modo claro'"
          aria-label="Alternar tema"
        >
          <i :class="['fas', theme === 'light' ? 'fa-moon' : 'fa-sun']"></i>
        </button>-->
        <div class="sb-brand-mark">
          {{ userDados?.user ? userDados.user[0].toUpperCase() : "S" }}
        </div>
        <div class="sb-brand-info" v-show="showLabels">
          <div class="sb-user-name">{{ userDados?.user ?? "USERNAME" }}</div>
          <div class="sb-schema">{{ currentSchema }}</div>
        </div>
        <button
          v-show="showLabels"
          class="sb-menu-btn"
          @click="dialog_a_show = true"
          title="Logout"
        >
          <i class="fas fa-sign-out-alt"></i>
        </button>
      </div>
    </div>

    <!-- Nav links -->
    <div class="sb-scroll">
      <div class="sb-nav-stack">
        <template
          v-for="(content, index) in filteredSidebarContent"
          :key="index"
        >
          <!-- Item com sub-menu (dropdown) -->
          <div v-if="content.children && content.visibility" class="sb-group">
            <button
              type="button"
              class="sb-link sb-group-toggle"
              :class="{ 'sb-link-active': isGroupActive(content) }"
              :title="content.side_bar_text"
              @click="toggleDropdown(index)"
            >
              <span class="sb-link-icon">
                <i :class="content.side_bar_logo"></i>
              </span>
              <span class="sb-link-text" v-show="showLabels">{{
                content.side_bar_text
              }}</span>
              <span class="sb-caret" v-show="showLabels">
                <i
                  :class="[
                    'fas',
                    openDropdown === index
                      ? 'fa-chevron-up'
                      : 'fa-chevron-down',
                  ]"
                ></i>
              </span>
            </button>
            <transition name="sb-collapse">
              <div
                v-show="openDropdown === index && showLabels"
                class="sb-submenu"
              >
                <template
                  v-for="(child, cIdx) in content.children.filter(
                    (c) => c.visibility,
                  )"
                  :key="cIdx"
                >
                  <hr v-if="child.separador" class="sb-divider" />
                  <router-link
                    v-else
                    :to="child.route"
                    class="sb-link-wrap"
                    @click="onNavClick"
                  >
                    <div
                      class="sb-link sb-sublink"
                      :class="{ 'sb-link-active': isChildActive(child) }"
                      :title="child.side_bar_text"
                    >
                      <span class="sb-link-icon">
                        <i :class="child.side_bar_logo"></i>
                      </span>
                      <span class="sb-link-text" v-show="showLabels">{{
                        child.side_bar_text
                      }}</span>
                    </div>
                  </router-link>
                </template>
              </div>
            </transition>
          </div>

          <!-- Item simples -->
          <router-link
            v-else-if="content.visibility"
            :to="content.route"
            class="sb-link-wrap"
            @click="onNavClick"
          >
            <div
              class="sb-link"
              :class="{ 'sb-link-active': matchesPath(content.route) }"
              :title="content.side_bar_text"
            >
              <span class="sb-link-icon">
                <i :class="content.side_bar_logo"></i>
              </span>
              <span class="sb-link-text" v-show="showLabels">{{
                content.side_bar_text
              }}</span>
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </aside>
  <DialogAction
    v-if="dialog_a_show"
    :propsData="dialog_a_data"
    @close="dialog_a_show = false"
    @confirmReturn="confirmReturn"
  />
</template>

<script>
import axios from "axios";
import permissionMixin from "@/permissionMixin.js";
import { UserData } from "@/extraData";
import DialogAction from "@/components/dialog/actionDialog.vue";
import { useTheme } from "@/composables/useTheme";

export default {
  mixins: [permissionMixin],
  setup() {
    const { theme, toggleTheme } = useTheme();
    return { theme, toggleTheme };
  },
  components: {
    DialogAction,
  },
  name: "AppSideBar",
  inheritAttrs: false,
  data() {
    return {
      currentSchema: "",
      UserData: UserData,
      userDados: JSON.parse(localStorage.getItem("user")) ?? null,
      baseURL: process.env.VUE_APP_URL_BASE,
      empresaExiste: false,
      isMobile: typeof window !== "undefined" ? window.innerWidth < 768 : false,
      mobileOpen: false,
      desktopCollapsed:
        typeof window !== "undefined"
          ? localStorage.getItem("sb_collapsed") === "1"
          : false,
      openDropdown: null,
      _resizeHandler: null,
      dialog_a_show: false,
      dialog_a_data: {
        title: "Sair",
        message: "Tens a certeza que queres terminar a sessão?",
        confirm: true,
        buttons: [
          {
            text: "Confirmar",
            color: "#1f6a1fc1",
            action: "proceed",
            entity: null,
          },
          {
            text: "Cancelar",
            color: "#a83838",
            action: "cancel",
            entity: null,
          },
        ],
      },

      side_bar_content: [
        {
          side_bar_logo: "fas fa-tachometer-alt",
          side_bar_text: "Dashboard",
          route: "/dashboard",
          visibility: this.validPermission("H0001"),
        },
        {
          side_bar_logo: "fas fa-chart-line",
          side_bar_text: "Análise",
          route: "/analise",
          visibility:
            this.validPermission("PT001") || this.validPermission("PE001"),
          children: [
            {
              side_bar_logo: "fas fa-chart-bar",
              side_bar_text: "Análise Estatística",
              route: "/analise",
              visibility: this.validPermission("PE001"),
            },
            {
              side_bar_logo: "fas fa-wand-magic-sparkles",
              side_bar_text: "Explorar dados",
              route: "/explorar",
              visibility: this.validPermission("PE001"),
            },
            {
              side_bar_logo: "fas fa-user-cog",
              side_bar_text: "Análise Técnico",
              route: "/analiseTecnico",
              visibility: this.validPermission("PT001"),
            },
          ],
        },
        {
          side_bar_logo: "fa-solid fa-cogs",
          side_bar_text: "Configurações",
          route: "/configuracoes",
          visibility: true,
        },
        {
          side_bar_logo: "fas fa-user-tag",
          side_bar_text: "Roles",
          route: "/roles",
          visibility: this.validPermission("R0001"),
        },
        {
          side_bar_logo: "fas fa-users",
          side_bar_text: "Utilizadores",
          route: "/utilizadores",
          visibility: this.validPermission("U0001"),
        },
        {
          side_bar_logo: "fas fa-handshake ",
          side_bar_text: "Clientes",
          route: "/clientes",
          visibility: this.validPermission("L0001"),
          children: [
            {
              side_bar_logo: "fas fa-handshake",
              side_bar_text: "Clientes",
              route: "/clientes",
              visibility: this.validPermission("L0001"),
            },
            {
              side_bar_logo: "fas fa-building-user",
              side_bar_text: "Sub-clientes",
              route: "/subclientes",
              visibility: this.validPermission("L0001"),
            },
            {
              side_bar_logo: "fas fa-map-marker-alt",
              side_bar_text: "Instalações",
              route: "/instalacoes",
              visibility: this.validPermission("L0001"),
            },
            {
              side_bar_logo: "fas fa-file-contract",
              side_bar_text: "Contratos",
              route: "/contratos",
              visibility: this.validPermission("L0001"),
            },
          ],
        },
        {
          side_bar_logo: "fas fa-truck-loading",
          side_bar_text: "Fornecedores",
          route: "/fornecedores",
          visibility: this.validPermission("F0001"),
        },
        {
          side_bar_logo: "fas fa-exchange-alt",
          side_bar_text: "Stocks",
          route: "/stocks",
          visibility: this.validPermission("SM0001"),
        },
        {
          side_bar_logo: "fas fa-warehouse",
          side_bar_text: "Armazens",
          route: "/armazens",
          visibility: this.validPermission("A0001"),
        },
        {
          side_bar_logo: "fas fa-car",
          side_bar_text: "Viaturas",
          route: "/viaturas",
          visibility: this.validPermission("V0001"),
        },
        {
          side_bar_logo: "fas fa-building",
          side_bar_text: "Sucursais",
          route: "/sucursais",
          visibility: this.validPermission("SU0001"),
        },
        {
          side_bar_logo: "fas fa-box-open",
          side_bar_text: "Familias",
          route: "/familia",
          visibility: this.validPermission("P0001"),
          children: [
            {
              side_bar_logo: "fas fa-sitemap",
              side_bar_text: "Família",
              route: "/familia",
              visibility: this.validPermission("P0001"),
            },
            {
              side_bar_logo: "fas fa-box",
              side_bar_text: "Produto",
              route: "/familia?view=produto",
              visibility: this.validPermission("P0001"),
            },
            {
              side_bar_logo: "fas fa-tags",
              side_bar_text: "Tipologia",
              route: "/familia?view=tipologia",
              visibility: this.validPermission("P0001"),
            },
            {
              side_bar_logo: "fas fa-tools",
              side_bar_text: "Equipamento",
              route: "/equipamentos",
              visibility: this.validPermission("E0001"),
            },
            {
              side_bar_logo: "fas fa-cogs",
              side_bar_text: "Associar Equipamento",
              route: "/associar",
              visibility: this.validPermission("E0001"),
            },
          ],
        },

        {
          side_bar_logo: "fas  fa-hard-hat",
          side_bar_text: "Negócios",
          route: "/negocio",
          visibility:
            this.validPermission("O0001") || this.validPermission("OE0001"),
          children: [
            {
              side_bar_logo: "fas fa-table-columns",
              side_bar_text: "Pipeline",
              route: "/negocio-kanban",
              visibility: this.validPermission("O0001"),
            },
            {
              side_bar_logo: "fas  fa-hard-hat",
              side_bar_text: "Negócios",
              route: "/negocio",
              visibility: this.validPermission("O0001"),
            },
            // Separa a vista geral das páginas por etapa
            {
              separador: true,
              visibility: this.validPermission("O0001"),
            },
            {
              side_bar_logo: "fas fa-calculator",
              side_bar_text: "Orçamentação",
              route: "/orcamentacao",
              visibility: this.validPermission("O0001"),
            },
            {
              side_bar_logo: "fas fa-file-signature",
              side_bar_text: "Adjudicação",
              route: "/adjudicacao",
              visibility: this.validPermission("O0001"),
            },
            {
              side_bar_logo: "fas  fa-hard-hat",
              side_bar_text: "Compras/A.Central",
              route: "/negocioextra",
              visibility: this.validPermission("OE0001"),
            },
            {
              side_bar_logo: "fas fa-calendar-check",
              side_bar_text: "Previsto",
              route: "/previsto",
              visibility: this.validPermission("O0001"),
            },
            {
              side_bar_logo: "fas fa-hard-hat",
              side_bar_text: "Execução/Operação",
              route: "/execucao",
              visibility: this.validPermission("O0001"),
            },
            
            
          ],
        },
        {
          side_bar_logo: "fas fa-newspaper",
          side_bar_text: "Artigos",
          route: "/artigos",
          visibility: this.validPermission("G0001"),
        },
        {
          side_bar_logo: "fas fa-calendar-alt",
          side_bar_text: "Planeamento",
          route: "/planeamentos2",
          visibility: this.validPermission("M0001"),
          children: [
            {
              side_bar_logo: "fas fa-calendar-check",
              side_bar_text: "Serviços",
              route: "/planeamentos2",
              visibility: this.validPermission("M0001"),
            },
            {
              side_bar_logo: "fas fa-map-location-dot",
              side_bar_text: "Mapa Serviços",
              route: "/mapaServicos",
              visibility: this.validPermission("M0001"),
            },
            {
              side_bar_logo: "fas fa-wand-magic-sparkles",
              side_bar_text: "Planeamento Automático",
              route: "/planeamentoAutomatico",
              visibility: this.validPermission("M0001"),
            },
            // {
            //   side_bar_logo: "fa-solid fa-arrows-left-right-to-line",
            //   side_bar_text: "Transferir Serviços",
            //   route: "/transferirServicos",
            //   visibility: this.validPermission("M0001"),
            // },
            {
              side_bar_logo: "fas fa-envelope",
              side_bar_text: "Notificar/Confirmar",
              route: "/notificarAgendamentos",
              visibility: this.validPermission("NS0001"),
            },
            {
              side_bar_logo: "fas fa-clock-rotate-left",
              side_bar_text: "Histórico OS",
              route: "/historicoOrdensServico",
              visibility: this.validPermission("M0001"),
            },
          ],
        },
        {
          side_bar_logo: "fas fa-right-left",
          side_bar_text: "Transferências",
          route: "/transferencia-artigos",
          visibility:
            this.validPermission("G0001") || this.validPermission("L0001"),
          children: [
            {
              side_bar_logo: "fas fa-newspaper",
              side_bar_text: "Artigos",
              route: "/transferencia-artigos",
              visibility: this.validPermission("G0001"),
            },
            {
              side_bar_logo: "fas fa-map-location-dot",
              side_bar_text: "Instalações",
              route: "/transferencia-instalacoes",
              visibility: this.validPermission("L0001"),
            },
            {
              side_bar_logo: "fas fa-building-user",
              side_bar_text: "Sub-clientes",
              route: "/transferencia-subclientes",
              visibility: this.validPermission("L0001"),
            },
          ],
        },
        {
          side_bar_logo: "fas fa-file-contract",
          side_bar_text: "Ordem Serviço",
          route: "/ordemservico",
          visibility: this.validPermission("S0001"),
        },
        {
          side_bar_logo: "fas fa-screwdriver-wrench",
          side_bar_text: "Correção Técnico",
          route: "/correcaoTecnico",
          visibility: this.validPermission("CT0001"),
        },
        {
          side_bar_logo: "fas fa-file-export",
          side_bar_text: "Exportações",
          route: "/exportacoes",
          visibility: this.validPermission("S0001"),
        },
        {
          side_bar_logo: "fas fa-file-invoice",
          side_bar_text: "Documentação",
          route: "/documentacao",
          visibility: this.validPermission("I0001"),
        },
        {
          side_bar_logo: "fas fa-tags",
          side_bar_text: "Tabela-Preço",
          route: "/tabelaPrecos",
          visibility: this.validPermission("B0001"),
        },
        {
          side_bar_logo: "fa-regular fa-address-book",
          side_bar_text: "Contactos",
          route: "/contacto",
          visibility: this.validPermission("N0001"),
        },
        {
          side_bar_logo: "fas fa-history",
          side_bar_text: "Histórico",
          route: "/historico",
          visibility: this.validPermission("K0001"),
        },
        {
          side_bar_logo: "fas fa-search",
          side_bar_text: "Pesquisa Artigo",
          route: "/pesquisa-artigo",
          visibility: this.validPermission("GP0001"),
        },
        {
          side_bar_logo: "fas fa-box-open",
          side_bar_text: "Recolhas Pendentes",
          route: "/recolhas-pendentes",
          visibility: this.validPermission("G0001"),
        },
        {
          side_bar_logo: "fas fa-bullhorn",
          side_bar_text: "Novidades",
          route: "/novidades",
          visibility: this.validPermission("RN0001"),
        },
      ],
    };
  },
  computed: {
    filteredSidebarContent() {
      if (!this.empresaExiste) {
        return this.side_bar_content.filter(
          (item) => item.route === "/configuracoes",
        );
      } else {
        return this.side_bar_content;
      }
    },
    showLabels() {
      // Mostra textos em mobile-aberto e em desktop expandido
      if (this.isMobile) return this.mobileOpen;
      return !this.desktopCollapsed;
    },
    collapseIcon() {
      if (this.isMobile) return "fa-times";
      return this.desktopCollapsed ? "fa-angles-right" : "fa-angles-left";
    },
    collapseTitle() {
      if (this.isMobile) return "Fechar menu";
      return this.desktopCollapsed ? "Expandir" : "Recolher";
    },
  },
  async mounted() {
    await this.checkEmpresaExistence();
    await this.fetchCurrentSchema();
    this.syncOpenDropdown();
    this.colapsarParaMapa();

    this._resizeHandler = () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 768;
      if (!this.isMobile && wasMobile) {
        // Saiu de mobile → garante drawer fechado
        this.mobileOpen = false;
      }
    };
    window.addEventListener("resize", this._resizeHandler);
  },

  beforeUnmount() {
    if (this._resizeHandler) {
      window.removeEventListener("resize", this._resizeHandler);
    }
  },

  methods: {
    async fetchCurrentSchema() {
      try {
        const response = await axios.get(`${this.baseURL}/api/v1/schema/atual`);
        if (response.data && response.data.schema) {
          this.currentSchema = response.data.schema; // Nome do schema obtido
        } else {
          this.currentSchema = "Schema não encontrado";
        }
      } catch (error) {
        console.error("Erro ao buscar empresa atual:", error);
        this.currentSchema = "Erro ao carregar empresa";
      }
    },
    async checkEmpresaExistence() {
      try {
        const response = await axios.get(
          `${this.baseURL}/api/v1/empresa/nome/`,
        );
        if (response.data && response.data.empresa) {
          this.empresaExiste = true;
        } else {
          this.empresaExiste = false;
        }
      } catch (error) {
        this.empresaExiste = false;
        console.error("Erro ao verificar a existência da empresa:", error);
      }
    },
    validPermission(codigo) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user && user.perfil && user.perfil.permissao) {
        return user.perfil.permissao.some(
          (perm) => perm.codigo === codigo && perm.autorizacao,
        );
      }
      return false;
    },

    async logout() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const res = await axios
          .post(`${this.baseURL}/api/v1/logout/${user.id}/`)
          .then((response) => {
            console.log("Logout:", response);
          });
      } catch (error) {
        console.log("Erro ao fazer logout:", error);
      }
      this.$router.push({ name: "signin" });
      localStorage.clear();
    },

    confirmReturn(action) {
      if (action === "proceed") {
        this.logout();
      } else {
        this.dialog_a_show = false;
      }
    },

    colapsarParaMapa() {
      // O mapa de serviços precisa do máximo de largura: colapsa a sidebar ao
      // entrar em /mapaServicos e restaura ao sair (sem mexer na preferência
      // guardada em localStorage).
      if (this.isMobile) return;
      if (this.$route.path === "/mapaServicos") {
        if (!this.desktopCollapsed) {
          this._expandidaAntesMapa = true;
          this.desktopCollapsed = true;
        }
      } else if (this._expandidaAntesMapa) {
        this._expandidaAntesMapa = false;
        this.desktopCollapsed = false;
      }
    },

    toggleSidebar() {
      if (this.isMobile) {
        this.mobileOpen = !this.mobileOpen;
      } else {
        this.desktopCollapsed = !this.desktopCollapsed;
        try {
          localStorage.setItem(
            "sb_collapsed",
            this.desktopCollapsed ? "1" : "0",
          );
        } catch (e) {
          // ignora erros de storage (ex.: modo privado)
        }
      }
    },

    onNavClick() {
      // Fecha o drawer ao navegar em mobile
      if (this.isMobile) {
        this.mobileOpen = false;
      }
    },

    toggleDropdown(index) {
      // Em desktop colapsado, expande primeiro para mostrar o sub-menu
      if (!this.isMobile && this.desktopCollapsed) {
        this.desktopCollapsed = false;
        try {
          localStorage.setItem("sb_collapsed", "0");
        } catch (e) {
          // ignora erros de storage
        }
      }
      this.openDropdown = this.openDropdown === index ? null : index;
    },

    matchesPath(path) {
      // Considera activo também nas sub-rotas (ex.: /clientes/12 → /clientes)
      return (
        this.$route.path === path || this.$route.path.startsWith(`${path}/`)
      );
    },

    isChildActive(child) {
      if (!child.route) return false; // separadores não são navegáveis
      const [path, queryStr] = child.route.split("?");
      if (!this.matchesPath(path)) return false;
      const view = queryStr ? new URLSearchParams(queryStr).get("view") : null;
      // Sem view na rota: ativo apenas quando a rota atual também não tem view
      return (this.$route.query.view ?? null) === view;
    },

    isGroupActive(content) {
      return (content.children || []).some((child) =>
        this.isChildActive(child),
      );
    },

    syncOpenDropdown() {
      // Abre automaticamente o grupo cujo filho corresponde à rota atual
      const idx = this.filteredSidebarContent.findIndex(
        (content) => content.children && this.isGroupActive(content),
      );
      if (idx !== -1) {
        this.openDropdown = idx;
      }
    },
  },

  watch: {
    $route() {
      this.syncOpenDropdown();
      this.colapsarParaMapa();
    },
  },
};
</script>

<style scoped>
/* ── Glass Sidebar ── */
.glass-sidebar {
  position: sticky;
  top: 0;
  height: calc(100vh - 36px);
  width: 260px;
  min-width: 260px;
  border-radius: 26px;
  background: radial-gradient(
      120% 120% at 0% 0%,
      rgba(138, 160, 255, 0.1),
      transparent 42%
    ),
    radial-gradient(
      100% 120% at 100% 100%,
      rgba(255, 123, 114, 0.08),
      transparent 38%
    ),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.06),
      rgba(255, 255, 255, 0.02)
    ),
    linear-gradient(180deg, rgba(16, 21, 38, 0.96), rgba(7, 10, 20, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.55);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(16px);
}

/* ── Top Section ── */
.sb-top {
  padding: 16px 14px 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.02);
}

.sb-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 12px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
}

.sb-brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  font-weight: 900;
  font-size: 16px;
  color: #d7fffe;
  letter-spacing: 0.02em;
  background: linear-gradient(
    180deg,
    rgba(33, 196, 184, 0.26),
    rgba(33, 196, 184, 0.1)
  );
  border: 1px solid rgba(33, 196, 184, 0.34);
  flex: 0 0 auto;
}

.sb-brand-info {
  flex: 1;
  min-width: 0;
}

.sb-user-name {
  font-weight: 860;
  font-size: 14px;
  letter-spacing: 0.2px;
  color: rgba(255, 255, 255, 0.96);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
}

.sb-schema {
  margin-top: 3px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.sb-menu-btn {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: 0.16s ease;
  flex: 0 0 auto;
  color: rgba(255, 123, 114, 0.85);
  font-size: 14px;
}
.sb-menu-btn:hover {
  background: rgba(255, 123, 114, 0.14);
  border-color: rgba(255, 123, 114, 0.35);
  transform: translateY(-1px);
}

/* ── Scroll Area ── */
.sb-scroll {
  padding: 12px 10px;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1 auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(138, 160, 255, 0.2) transparent;
}

.sb-scroll::-webkit-scrollbar {
  width: 4px;
}
.sb-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.sb-scroll::-webkit-scrollbar-thumb {
  background: rgba(138, 160, 255, 0.25);
  border-radius: 999px;
}

/* ── Nav Stack ── */
.sb-nav-stack {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sb-link-wrap {
  text-decoration: none;
}

.sb-link {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 42px;
  padding: 8px 12px;
  border-radius: 14px;
  border: 1px solid transparent;
  color: rgba(255, 255, 255, 0.84);
  transition: all 0.15s ease;
  font-size: 14px;
}

.sb-link:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.sb-link-active {
  background: rgba(138, 160, 255, 0.16) !important;
  border-color: rgba(138, 160, 255, 0.34) !important;
  color: rgba(255, 255, 255, 0.96);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
}

.sb-link-icon {
  width: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--icon, #ff9b05);
  opacity: 0.92;
  flex: 0 0 auto;
  font-size: 14px;
}

.sb-link-text {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
}

/* ── Dropdown / Sub-menu ── */
.sb-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sb-group-toggle {
  width: 100%;
  background: transparent;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
}

.sb-caret {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  opacity: 0.7;
  flex: 0 0 auto;
  transition: opacity 0.15s ease;
}

.sb-submenu {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 14px;
  padding-left: 10px;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  overflow: hidden;
}

.sb-sublink {
  min-height: 36px;
  font-size: 13px;
}

/* Barreira visual entre grupos de sub-itens */
.sb-divider {
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  margin: 6px 4px 6px 0;
}

.sb-sublink .sb-link-icon {
  font-size: 12px;
}

/* Animação de abertura do sub-menu */
.sb-collapse-enter-active,
.sb-collapse-leave-active {
  transition: max-height 0.22s ease, opacity 0.22s ease;
  max-height: 240px;
}
.sb-collapse-enter-from,
.sb-collapse-leave-to {
  max-height: 0;
  opacity: 0;
}

/* ── Toggle (interno) ── */
.sb-collapse-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: 0.15s ease;
  flex: 0 0 auto;
  font-size: 12px;
}
.sb-collapse-btn:hover {
  background: rgba(138, 160, 255, 0.18);
  border-color: rgba(138, 160, 255, 0.34);
}

.sb-theme-btn {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,.14);
  background: rgba(255,255,255,.06);
  color: rgba(255,204,102,.85);
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: .15s ease;
  flex: 0 0 auto;
  font-size: 12px;
}
.sb-theme-btn:hover {
  background: rgba(255,204,102,.16);
  border-color: rgba(255,204,102,.34);
}

/* ── Estado: desktop colapsado (apenas ícones) ── */
.glass-sidebar.is-collapsed {
  width: 68px;
  min-width: 68px;
}

.glass-sidebar.is-collapsed .sb-top {
  padding: 12px 8px 10px;
}

.glass-sidebar.is-collapsed .sb-brand {
  padding: 8px 6px;
  gap: 6px;
  flex-direction: column;
}

.glass-sidebar.is-collapsed .sb-brand-mark {
  width: 36px;
  height: 36px;
  font-size: 14px;
}

.glass-sidebar.is-collapsed .sb-link {
  justify-content: center;
  padding: 8px;
  min-height: 38px;
}

.glass-sidebar.is-collapsed .sb-scroll {
  padding: 10px 6px;
}

/* Quando o sidebar está em modo mobile (drawer), sai do flow do layout */
.glass-sidebar.is-mobile-closed,
.glass-sidebar.is-mobile-open {
  position: fixed;
  top: 12px;
  left: 12px;
  bottom: 12px;
  height: auto;
  width: min(86vw, 300px);
  min-width: 0;
  z-index: 1100;
  transition: transform 0.25s ease;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.65);
}

.glass-sidebar.is-mobile-closed {
  transform: translateX(calc(-100% - 24px));
  pointer-events: none;
}

.glass-sidebar.is-mobile-open {
  transform: translateX(0);
}

/* ── Backdrop do drawer ── */
.sb-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 1090;
  backdrop-filter: blur(2px);
}

.sb-fade-enter-active,
.sb-fade-leave-active {
  transition: opacity 0.2s ease;
}
.sb-fade-enter-from,
.sb-fade-leave-to {
  opacity: 0;
}

/* ── Botão flutuante para abrir drawer em mobile ── */
.sb-mobile-toggle {
  position: fixed;
  top: 12px;
  left: 12px;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(16, 21, 38, 0.92);
  color: rgba(255, 255, 255, 0.92);
  cursor: pointer;
  display: grid;
  place-items: center;
  font-size: 16px;
  z-index: 1080;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(8px);
}
.sb-mobile-toggle:hover {
  background: rgba(138, 160, 255, 0.22);
}

/* ── Responsivo ── */
@media (max-width: 767px) {
  /* Em mobile, o sidebar nunca participa do layout flex */
  .glass-sidebar {
    flex: none !important;
  }
}
</style>
